import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, H6, UL, LI, P } from '../../../AbstractElements';
import { Activity, DailyDropdown } from '../../../Constant';
import { ActivityData } from '../../../Data/DefaultDashboard';
import DropdownCommon from '../../Common/Dropdown';

const ActivityCard = (propData) => {


  
  
  return (
    <Col  sm='14' className='notification box-col-6' style={{alignItems: "center",justifyContent: "center", marginLeft:'10px'}}>
      <Card className='height-equal'>
        <CardHeader className='card-no-border'>
          <div className='header-top' style={{alignItems: "center",justifyContent: "center"}}>
            <H6 attrH5={{ className: 'm-0' }} style={{alignItems: "center",justifyContent: "center"}}>{"APPLICATION REVIEW STATUS"}</H6>
            
          </div>
        </CardHeader>
        {propData.timelineData && (<CardBody className='pt-0'> 
          <UL>
            {propData.timelineData.map((item, i) => (
              <LI key={i} attrLI={{ className: 'd-flex' }}>
                <div className={`activity-dot-${item.color}`} />
                <div className='ms-3' style={{width:"100%"}}>
                  <P attrPara={{ className: 'd-flex justify-content-between mb-2',width:'100%' }}>
                    <span className='date-content light-background'>{item.subTitle}</span>
                    <span className='font-primary font-weight-bold' style={{alignItems: "right",justifyContent: "right", color: "primary"}} >{item.time}</span>
                  </P>
                  <H6>
                    {item.title}
                    <span className='dot-notification' />
                  </H6>
                  <p className='f-light'>{item.dis}
                  <span className='font-secondary font-weight-bold' style={{alignItems: "right",justifyContent: "right", color: "secondary"}} >{item.feedback}</span></p>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>)}
      </Card>
    </Col>
  );
};

export default ActivityCard;
